module.exports = __webpack_public_path__ + "static/media/GLOBAL-INFRASTRUCTURE.7d34bcee.svg";